import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$')({
  component: NotFoundPage
})

function NotFoundPage() {
  return (
    <main className="mx-auto max-w-md px-4 py-12 text-center">
      <h1 className="mb-2 text-2xl font-bold text-gray-900">
        Página não encontrada
      </h1>
      <p className="text-muted-foreground">
        A rota solicitada ainda não foi migrada para o Vite.
      </p>
    </main>
  )
}
